module.exports = __webpack_public_path__ + "img/赤芍.7fadea50.jpg";